export const scrollTop = () => {
  window.scrollTo(0, 0);
};
